import React, { useEffect } from 'react';
import classNames from 'classnames';
import styles from './assets/internal-info.module.scss';

import { IInternal } from 'src/types/internal';
import RoleLayout from 'src/components/layout/RoleLayout';
import { RouteComponentProps } from 'react-router';

export interface StateProps {
    internal: Partial<IInternal> | null;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const InternalInfo: React.FunctionComponent<Props> = ({
    internal,
    getData,
    match: {
        params: { id },
    },
}: Props) => {
    useEffect(() => {
        if (id) {
            getData(id);
        }
        // eslint-disable-next-line
    }, [getData]);

    if (!internal) {
        return null;
    }
    return (
        <RoleLayout>
            <div>
                <h2>EXPENSES {`>`}</h2>
            </div>

            <div className={classNames(styles.infoWrap)}>
                <div className={classNames(styles.infoItems)}></div>
            </div>
        </RoleLayout>
    );
};

export default InternalInfo;
